export default "__VITE_PUBLIC_ASSET__d303d3bb__"